import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import enTranslations from './locales/en.json';
import zhCnTranslations from './locales/zh-cn.json';

const resources = {
  en: {
    translation: enTranslations
  },
  zh: {
    translation: zhCnTranslations
  },
  'zh-CN': {
    translation: zhCnTranslations
  },
  'zh-cn': {
    translation: zhCnTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en', // Get from localStorage or default to 'en'
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    // Store language preference in localStorage
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    // Debug info
    debug: false
  });

export default i18n;